import React from 'react';
import styled from "styled-components";
import { device }  from "../utlis/device";

const ImageContainer = styled.div ` 
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const ImageStyle = styled.img `
    width: 300px;
    height: 300px;
    @media ${device.mobileL} {
    width: 300px;
    height: 300px;
  }
  @media ${device.mobileM} {
    width: 300px;
    height: 300px;
  }
  @media (max-width: 320px) {
    width: 250px;
    height: 250px;
  }
  @media ${device.mobileS} {
    width: 250px;
    height: 250px;
  }
  @media (max-width: 280px) {
    width: 200px;
    height: 200px;
  }
    
`

function HeaderImage (props) {

  return (
    
    <ImageContainer>
      <ImageStyle src="/images/eastDevon.png" alt='east-devonly-christmas' />
    </ImageContainer>
  );
}

export default HeaderImage;